import { urlParams, TEAMS_USER_IMPRESSION_SERVICE_ID } from "./../constants/AppConstants";
import { app } from "@microsoft/teams-js";

function getAllUrlParams() {
  var allUrlParams = new URLSearchParams(window.location.search);
  var resourceObj = {};
  for (var key of allUrlParams.keys()) {
    resourceObj[key] = allUrlParams.get(key);
  }
  var resourceStr = JSON.stringify(resourceObj);
  return encodeURIComponent(resourceStr);
}
export let TeamsController = {
    service: "Teams",
    crmPhoneSearchSelect: true,
    landingPage: true,
    landingPagePathname: "/teams/landing",
    surveyFormUrl: "https://zfrmz.com/bFnoYZLikTl34Sg2ZVHI",
    doSurvey: true,
    contactsEnabled: true,
    sideBarExtend: {
        hideAutomationSideBar: true,
        hideVoiceSideBar: true,
        contactsSideBar: true,
    },
    UNIPILE_WHATSAPP_GALLERY: [
        {
            videoUrl: "https://www.youtube.com/embed/pH4vGpSc8i0",
        },
        {
            videoUrl: "",
        },
    ],
    init: function () {
        return new Promise((resolve, reject) => {
            if (window.parent !== window) {
                // Only initialize if inside an iframe (like in Teams)
                import("@microsoft/teams-js")
                    .then((teams) => {
                        teams.app
                            .initialize()
                            .then(() => {
                                teams.app.notifySuccess();
                                resolve();
                            })
                            .catch((error) => {
                                resolve(error);
                            });
                    })
                    .catch((error) => {
                        resolve(error);
                    });
            } else {
                resolve();
            }
        });
    },

    isCreditAccessible: function () {
        return new Promise((resolve, reject) => {
            if (app && window.parent !== window) {
                app.getContext().then((context) => {
                    if (["desktop", "web"].includes(context.app.host.clientType)) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
            } else {
                resolve(true);
            }
        });
    },

    getCustomAuthUrl: function (appProperties) {
        return new Promise((resolve, reject) => {
            const redirectUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${
                appProperties?.leftServiceClientDetails?.clientId
            }&redirect_uri=https://api.oapps.xyz/rest/api/v2/redirect&state=${
                appProperties?.osyncId
            }::${TEAMS_USER_IMPRESSION_SERVICE_ID}::${TEAMS_USER_IMPRESSION_SERVICE_ID}::true&scope=${encodeURIComponent(
                "https://api.interfaces.records.teams.microsoft.com/user_impersonation offline_access"
            )}&access_type=offline&prompt=select_account`;
            resolve(redirectUrl);
        });
    },

    pricingLink: function (appProperties) {
        return new Promise((resolve, reject) => {
            const { hash, osyncId, domain } = appProperties;
            var leftServiceId = urlParams.get("leftServiceId");
            var leftServiceName = urlParams.get("service");
            var allUrlParams = getAllUrlParams();
            var redirectSendSMSFromModule = domain + "/persons/list";
            var hrefUrl = `/pricing?productId=102&groupName=OMNI_CHANNEL&domain=${domain}&hash=${hash}&leftServiceId=${leftServiceId}&osyncId=${osyncId}&leftServiceName=${leftServiceName}&urlParams=${allUrlParams}&redirectSendSMSFromModule=${redirectSendSMSFromModule}`;

            resolve(hrefUrl);
        });
    },
    /** URL query wins when set (task module / deep link); otherwise Teams host context. */
    getUserData: function (_isUserHashNeeded) {
        return new Promise((resolve) => {
            const fromUrl = {
                companyId: urlParams.get("companyId"),
                emailId: urlParams.get("email"),
                userId: urlParams.get("userId"),
                domain: urlParams.get("domain"),
            };

            const merge = (context) => {
                const tenantId = context?.user?.tenant?.id ?? null;
                const teamsUserId = context?.user?.id ?? null;
                const emailFromTeams = context?.user?.loginHint || context?.user?.userPrincipalName || null;

                const companyId = fromUrl.companyId || tenantId;
                const userId = fromUrl.userId || teamsUserId;
                const emailId = fromUrl.emailId || emailFromTeams;
                const domain = fromUrl.domain;

                return {
                    companyId,
                    userId,
                    companyOrgId: companyId,
                    domain,
                    emailId,
                };
            };

            const inTeamsShell = typeof window !== "undefined" && window.parent !== window;
            if (app && inTeamsShell) {
                app.getContext()
                    .then((context) => resolve(merge(context)))
                    .catch(() => {
                        resolve(merge(null));
                    });
            } else {
                resolve(merge(null));
            }
        });
    },

    getContext: function () {
        return new Promise((resolve) => {
            const inTeamsShell = typeof window !== "undefined" && window.parent !== window;
            if (app && inTeamsShell) {
                app.getContext()
                    .then((context) => resolve(context))
                    .catch(() => {
                        resolve(null);
                    });
            } else {
                resolve(null);
            }
        });
    },

    defaultSettingValue: {
        emailNotification: {
            sendEmail: true,
            accountOwner: true,
        },
        userNotification: "true",
        sharedInbox: "user",
        contactAssignment: "crmLeadOwner",
    },
    getAssociatedObjectType: function () {
        return new Promise((resolve, reject) => {
            resolve("Contacts");
        });
    },
    getUrlParamsForRedirection: function (isNewWindow, appProperties) {
        return new Promise((resolve, reject) => {
            var redirectUrl = `leftServiceId=${appProperties.leftServiceId || urlParams.get("leftServiceId")}&service=teams&domain=org${
                appProperties.companyId
            }&userId=${appProperties.userId}&companyId=${appProperties.companyId}`;
            resolve(redirectUrl);
        });
    },

    async testing() {
        // const teams = await import("@microsoft/teams-js");
        // await teams.app.initialize();
        // const context = await teams.app.getContext();
        // console.log("debug_kk Teams context:", context);
        // return context;
        return {
            app: {
                locale: "en-gb",
                sessionId: "a9238a11-f9f8-419c-8e68-e964e676ca16",
                theme: "dark",
                iconPositionVertical: -5,
                osLocaleInfo: {
                    platform: "macos",
                    regionalFormat: "en-gb",
                    shortDate: "dd/MM/yyyy",
                    longDate: "dd MMMM yyyy",
                    shortTime: "HH:mm",
                    longTime: "HH:mm:ss",
                    timezone: "Asia/Calcutta",
                },
                parentMessageId: "",
                userClickTime: 1771505746276,
                userClickTimeV2: 0,
                userFileOpenPreference: "inline",
                host: {
                    name: "TeamsModern",
                    clientType: "web",
                    sessionId: "04b1074d-1601-44b5-ae10-d515f3beba37",
                    ringId: "general",
                },
                appLaunchId: "9a20c733-4985-466c-9f2a-e432972cff64",
                appId: {
                    appIdAsString: "8ce86a2f-24ab-449a-afa2-405b5b652945",
                },
                manifestVersion: "1.17",
            },
            page: {
                id: "",
                frameContext: "task",
                subPageId: "",
                isFullScreen: false,
                isMultiWindow: false,
                isBackgroundLoad: false,
                sourceOrigin: "",
            },
            user: {
                id: "f2e00f87-e4aa-47c3-9df6-96aaca0eb632",
                displayName: "",
                licenseType: "SmbNonVoice",
                loginHint: "sabari@dev.hellosend.com",
                userPrincipalName: "sabari@dev.hellosend.com",
                tenant: {
                    id: "c57f574b-8b53-44f7-b505-a50b118595f7",
                    teamsSku: "enterprise",
                },
            },
            channel: {
                id: "19:d7cef4ad55394f8fa951807fcbc2eebb@thread.tacv2",
                displayName: "testingg",
                relativeUrl: "/sites/DEVTEAM/Shared Documents/testingg",
                membershipType: "Regular",
                defaultOneNoteSectionId: "",
            },
            team: {
                internalId: "19:k_iyfcJzETO4etRi0MIo2P6pEILCG68gmXfu-ZxeIhI1@thread.tacv2",
                displayName: "DEV TEAM",
                type: 0,
                groupId: "8b57dd95-b21d-42d9-89c6-7ac2396a6b6d",
                isArchived: false,
                userRole: 0,
            },
            sharePointSite: {
                teamSiteUrl: "https://oappshellosend.sharepoint.com/sites/DEVTEAM",
                teamSiteDomain: "oappshellosend.sharepoint.com",
                teamSitePath: "/sites/DEVTEAM",
                teamSiteId: "",
            },
            dialogParameters: {},
        };
    },
};
